/**
 *
 * Header
 *
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Icon } from "components";
import { Dropdown, Menu, Button, Popover } from "antd";
import Strings from "utils/strings";
import { setLogout, setLanguage, setUser, setLocation } from "store/actions";

import logo from "assets/images/logos/fertiberia-tech-gray.png";
import UserPlaceholder from "assets/images/placeholders/placeholder-profile.png";
import "./styles.scss";
import { translate } from "utils/utils";

import ReactDOM from "react-dom";
//@ts-ignore
import SmartBanner from "react-smartbanner";
import "react-smartbanner/dist/main.css";
import strings from "utils/strings";

/* eslint-disable react/prefer-stateless-function */
export class Header extends Component<any, any> {
	constructor(props: any) {
		super(props);
		this.state = {
			open: false,
			selectedLanguage: "pt",
			isMobile: window.innerWidth < 992,
		};

		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.handleResize = this.handleResize.bind(this);
		window.addEventListener("resize", this.handleResize);
	}

	componentDidMount() {
		let reduxLanguage = this.props.language;
		if (!reduxLanguage) {
			const browserLang: any = navigator.language.substring(0, 2);
			if (["en", "pt", "fr", "es"].includes(browserLang)) {
				reduxLanguage = browserLang;
				this.props.dispatch(setLanguage(browserLang));
				this.setState({ selectedLanguage: browserLang });
			} else reduxLanguage = this.state.selectedLanguage;
		}
		Strings.setLanguage(reduxLanguage);

		this.handleResize();

		ReactDOM.render(<SmartBanner title={"Fertiberia"} />, document.getElementById("app_banner"));
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	toggleSidebar() {
		const { onToggleSidebar } = this.props;
		onToggleSidebar();
	}

	goToProfile() {
		const { dispatch } = this.props;
		dispatch(push("/profile"));
	}

	logout() {
		const { dispatch } = this.props;

		localStorage.removeItem("token");
		dispatch(setLogout());
		dispatch(push("/"));
	}

	handleResize() {
		this.setState({ isMobile: window.innerWidth < 992 });
	}

	renderBurger() {
		const { sidebarOpen } = this.props;
		const { isMobile } = this.state;

		if (!isMobile) return null;

		return (
			<div className="BurgerContainer" onClick={this.toggleSidebar}>
				{sidebarOpen ? (
					<Icon name="dots-vertical" className="BurgerMenu __bigger" />
				) : (
					<Icon name="Menu" className="BurgerMenu" />
				)}
			</div>
		);
	}

	renderTopSidebar() {
		const { dispatch } = this.props;

		const { pathname } = window.location;

		return (
			<div className="TopSidebar">
				<div className="TopSidebarMenus">
					{/* <a
						className={`TopSidebarMenuIndividual ${pathname === "/library" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/library"));
						}}
						href="/library"
					>
						<span>{Strings.sidebar.library}</span>
					</a> */}
					<a
						className={`TopSidebarMenuIndividual ${pathname === "/deficiencies-identifying" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/deficiencies-identifying"));
						}}
						href="/deficiencies-identifying"
					>
						<span>{Strings.sidebar.deficiencyIdentification}</span>
					</a>
					<a
						className={`TopSidebarMenuIndividual ${pathname === "/agronomic-services" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/agronomic-services"));
						}}
						href="/agronomic-services"
					>
						<span>{Strings.sidebar.agronomicServices}</span>
					</a>
					<a
						className={`TopSidebarMenuIndividual ${pathname === "/meteorology" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/meteorology"));
						}}
						href="/"
					>
						<span>{Strings.sidebar.meteorology}</span>
					</a>
					<a
						className={`TopSidebarMenuIndividual ${pathname === "/news" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/news"));
						}}
						href="/"
					>
						<span>{Strings.sidebar.news}</span>
					</a>
					<a
						className={`TopSidebarMenuIndividual ${pathname === "/adp-products" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/adp-products"));
						}}
						href="/adp-products"
					>
						<span>{Strings.sidebar.adpClassic}</span>
					</a>
					<a
						className={`TopSidebarMenuIndividual ${pathname === "/contact" && "__active"}`}
						onClick={(e) => {
							e.preventDefault();
							dispatch(push("/contact"));
						}}
						href="/contact"
					>
						<span>{Strings.sidebar.contacts}</span>
					</a>
				</div>
			</div>
		);
	}

	renderLinks() {
		const { dispatch, aboutUs } = this.props;

		const { pathname } = window.location;

		return (
			<>
				<a
					className={`HeaderMenuIndividual ${pathname === "/" && "__active"}`}
					onClick={(e) => {
						e.preventDefault();
						dispatch(push("/"));
					}}
					href="/"
				>
					<span>{Strings.sidebar.home.toUpperCase()}</span>
				</a>
				<a
					className={`HeaderMenuIndividual ${pathname === "/page/au" && "__active"}`}
					onClick={(e) => {
						e.preventDefault();
						dispatch(push("/page/au"));
					}}
					href="/page/au"
				>
					<span>{((aboutUs && translate(aboutUs.title)) || Strings.sidebar.aboutUs).toUpperCase()}</span>
				</a>
				<a
					className={`HeaderMenuIndividual ${pathname === "/products" && "__active"}`}
					onClick={(e) => {
						e.preventDefault();
						dispatch(push("/products"));
					}}
					href="/products"
				>
					<span>{Strings.sidebar.products.toUpperCase()}</span>
				</a>
				<a
					className={`HeaderMenuIndividual ${pathname === "/cultures" && "__active"}`}
					onClick={(e) => {
						e.preventDefault();
						dispatch(push("/cultures"));
					}}
					href="/cultures"
				>
					<span>{Strings.sidebar.cultures.toUpperCase()}</span>
				</a>
				<a
					className={`HeaderMenuIndividual ${pathname === "/promoters" && "__active"}`}
					onClick={(e) => {
						e.preventDefault();
						dispatch(push("/promoters"));
					}}
					href="/promoters"
				>
					<span>{Strings.sidebar.promoters.toUpperCase()}</span>
				</a>
			</>
		);
	}

	renderLocationSelector() {
		const { location, dispatch } = this.props;
		const { isMobile } = this.state;

		const flags = {
			pt: "https://flagcdn.com/pt.svg",
			es: "https://flagcdn.com/es.svg",
			fr: "https://flagcdn.com/fr.svg",
			gr: "https://flagcdn.com/gr.svg",
			global: "https://flagcdn.com/un.svg",
		};

		const currentFlag = flags[location as keyof typeof flags] || flags.pt;

		const getCountryLabel = (location: string) => {
			switch (location) {
				case "pt":
					return strings.locations.portugal;
				case "es":
					return strings.locations.spain;
				case "fr":
					return strings.locations.france;
				case "gr":
					return strings.locations.greece;
				case "global":
					return strings.locations.otherCountries;
			}
		};

		const locationContent = (
			<div className="HeaderLanguageSelectorContent">
				<div className="HeaderLanguageSelectorContentText">
					<label className="HeaderLanguageSelectorContentLabel">{strings.fields.country}</label>
					<div
						className={`HeaderLanguageSelectorContentTextItem ${location === "pt" && "__active"}`}
						onClick={() => dispatch(setLocation("pt"))}
					>
						<img src={flags.pt} alt="Flag" width={20} height={16} />
						<p>{strings.locations.portugal}</p>
					</div>
					<div
						className={`HeaderLanguageSelectorContentTextItem ${location === "es" && "__active"}`}
						onClick={() => dispatch(setLocation("es"))}
					>
						<img src={flags.es} alt="Flag" width={20} height={16} />
						<p>{strings.locations.spain}</p>
					</div>
					{/* <div
						className={`HeaderLanguageSelectorContentTextItem ${location === "fr" && "__active"}`}
						onClick={() => dispatch(setLocation("fr"))}
					>
						<img src={flags.fr} alt="Flag" width={20} height={16} />
						<p>{strings.locations.france}</p>
					</div>
					<div
						className={`HeaderLanguageSelectorContentTextItem ${location === "gr" && "__active"}`}
						onClick={() => dispatch(setLocation("gr"))}
					>
						<img src={flags.gr} alt="Flag" width={20} height={16} />
						<p>{strings.locations.greece}</p>
					</div>
					<div
						className={`HeaderLanguageSelectorContentTextItem ${location === "global" && "__active"}`}
						onClick={() => dispatch(setLocation("global"))}
					>
						<img src={flags.global} alt="Flag" width={20} height={16} />
						<p>{strings.locations.otherCountries}</p>
					</div> */}
				</div>
			</div>
		);

		return (
			<Popover
				placement="bottomRight"
				content={locationContent}
				trigger="click"
				className="HeaderLanguageSelector"
			>
				<Button className="HeaderLanguageSelectorButton">
					<div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
						<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
							<img src={currentFlag} alt="Flag" width={20} height={16} />
							{!isMobile && <span>{getCountryLabel(location)}</span>}
						</div>
						{!isMobile && (
							<div
								style={{
									fontSize: 12,
									color: "#666",
									display: "flex",
								}}
							>
								{strings.fields.country}
							</div>
						)}
					</div>
					<Icon name="back1" className="HeaderLanguageSelectorButtonIcon" />
				</Button>
			</Popover>
		);
	}

	renderLanguageSelector() {
		const { language, dispatch } = this.props;
		const { isMobile } = this.state;

		const languageFlags = {
			pt: "https://flagcdn.com/pt.svg",
			es: "https://flagcdn.com/es.svg",
			fr: "https://flagcdn.com/fr.svg",
			gr: "https://flagcdn.com/gr.svg",
			en: "https://flagcdn.com/gb.svg",
		};

		const currentLanguage = languageFlags[language as keyof typeof languageFlags] || languageFlags.pt;

		const LANGUAGES = [
			{
				value: "pt",
				label: strings.language.portuguese,
			},
			{
				value: "es",
				label: strings.language.spanish,
			},
			// {
			// 	value: "fr",
			// 	label: strings.language.french,
			// },
			// {
			// 	value: "gr",
			// 	label: strings.language.greek,
			// },
			// {
			// 	value: "en",
			// 	label: strings.language.english,
			// },
		];

		const getLanguageLabel = (language: string) => {
			switch (language) {
				case "pt":
					return strings.language.portuguese;
				case "es":
					return strings.language.spanish;
				case "fr":
					return strings.language.french;
				case "gr":
					return strings.language.greek;
				case "en":
					return strings.language.english;
			}
		};

		const languageContent = (
			<div className="HeaderLanguageSelectorContent">
				<div className="HeaderLanguageSelectorContentText">
					<label className="HeaderLanguageSelectorContentLabel">{strings.language.header}</label>
					{LANGUAGES.map((lang: any) => (
						<div
							key={lang.value}
							className={`HeaderLanguageSelectorContentTextItem ${language === lang.value && "__active"}`}
							onClick={() => {
								dispatch(setLanguage(lang.value));
								Strings.setLanguage(lang.value);
								this.setState({ selectedLanguage: lang.value });
							}}
						>
							<p>{lang.label}</p>
						</div>
					))}
				</div>
			</div>
		);

		return (
			<Popover
				placement="bottomRight"
				content={languageContent}
				trigger="click"
				className="HeaderLanguageSelector"
			>
				<Button className="HeaderLanguageSelectorButton">
					<div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
						<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
							<img src={currentLanguage} alt="Flag" width={20} height={16} />
							{!isMobile && <span>{getLanguageLabel(language)}</span>}
						</div>
						{!isMobile && (
							<div
								style={{
									fontSize: 12,
									color: "#666",
									display: "flex",
								}}
							>
								{strings.language.header}
							</div>
						)}
					</div>
					<Icon name="back1" className="HeaderLanguageSelectorButtonIcon" />
				</Button>
			</Popover>
		);
	}

	renderTitle() {
		const { isMobile } = this.state;
		const { user, dispatch } = this.props;

		if (user) {
			const img = new Image();
			img.src = user.photo;

			img.onerror = () => {
				dispatch(setUser({ ...user, photo: UserPlaceholder }));
			};
		}

		const menu = (
			<Menu onClick={() => {}}>
				<Menu.Item
					key="1"
					style={{
						height: 40,
						display: "flex",
						alignItems: "center",
					}}
					icon={<Icon style={{ marginRight: 10 }} name="user2" />}
					onClick={() => dispatch(push("/profile"))}
				>
					{Strings.generic.profile}
				</Menu.Item>
				<Menu.Item
					key="separator"
					style={{
						height: 1,
						backgroundColor: "#EEE",
						padding: 0,
					}}
				/>
				<Menu.Item
					key="2"
					style={{
						height: 40,
						display: "flex",
						alignItems: "center",
					}}
					onClick={() => this.logout()}
					icon={<Icon style={{ marginRight: 10 }} name="logout" />}
				>
					{Strings.authentication.signOut}
				</Menu.Item>
			</Menu>
		);

		return (
			<React.Fragment>
				<div className="HeaderLeftSection">
					{this.renderBurger()}
					{(!isMobile && (
						<>
							<a
								href="/"
								className="HeaderLogo"
								onClick={(e: any) => {
									e.preventDefault();
									dispatch(push("/"));
								}}
							>
								<img src={logo} alt="App Logo" />
							</a>
							<div className="HeaderMenus">{this.renderLinks()}</div>
						</>
					)) ||
						null}
				</div>
				<div className="HeaderRightSection">
					{this.renderLocationSelector()}
					{this.renderLanguageSelector()}
					{(!user && (
						<Button
							className="HeaderLoginButton"
							type="primary"
							// icon={<Icon name="user2" style={{ marginRight: 10 }} />}
							onClick={() => dispatch(push("/login"))}
						>
							<span>{Strings.authentication.login_Register}</span>
						</Button>
					)) ||
						null}
					{(user && (
						<Dropdown overlay={menu} trigger={["click"]}>
							<div className="HeaderUserContainer">
								{(!isMobile && <span>{user.name}</span>) || null}
								{/* <div className="HeaderUserAvatar"> */}
								<img
									className="HeaderUserAvatar"
									src={user.photo || UserPlaceholder}
									alt="User Avatar"
								/>
								{/* </div> */}
							</div>
						</Dropdown>
					)) ||
						null}
				</div>
			</React.Fragment>
		);
	}

	render() {
		const { isMobile } = this.state;
		return (
			<>
				{!isMobile && this.renderTopSidebar()}
				<div className="HeaderContainer">
					<div id="AppHeader" className="Header">
						{this.renderTitle()}
					</div>
				</div>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	router: state.router,
	title: state.title,
	user: state.user,
	language: state.language,
	settings: state.settings,
	location: state.location,
});

export default connect(mapStateToProps)(Header);
